'use strict';
/*
  utypisk — punk / Danish-indie kinetic. Heavy type, red strobe, hand-sketch
  doodles that burst on the beat, screen-shake, ghost slab letters.
  (Generalised port of the original demo look.)
*/
const { layoutCue } = require('./_common');
const { roundRect, FONTS } = require('../lib/draw');

const palette = { bg: '#000000', fg: '#faf5ef', accent: '#ff1717', ink: '#0e0e0e' };

// ---- doodle generators (vector strokes in unit space) ----
const R = (rnd, a, b) => a + rnd() * (b - a);
function gCircle(rnd){const p=[],n=26,loops=R(rnd,1,1.35),wob=R(rnd,.08,.22);for(let i=0;i<=n;i++){const a=i/n*Math.PI*2*loops,r=1+Math.sin(a*R(rnd,2,5))*wob;p.push([Math.cos(a)*r,Math.sin(a)*r]);}return[p];}
function gSpiral(rnd){const p=[],n=44,t=R(rnd,2.2,3.4);for(let i=0;i<=n;i++){const f=i/n,a=f*Math.PI*2*t,r=f;p.push([Math.cos(a)*r,Math.sin(a)*r]);}return[p];}
function gZig(rnd){const p=[],n=R(rnd,5,9);for(let i=0;i<=n;i++)p.push([(i/n*2-1),(i%2?-.5:.5)+R(rnd,-.1,.1)]);return[p];}
function gBolt(){return[[[-.2,-1],[.25,-.2],[-.15,-.05],[.3,1],[.05,.15],[-.25,0]]];}
function gStar(){const p=[],n=5;for(let i=0;i<=n*2;i++){const a=i/(n*2)*Math.PI*2-Math.PI/2,r=i%2?.42:1;p.push([Math.cos(a)*r,Math.sin(a)*r]);}return[p];}
function gArrow(){return[[[-1,0],[1,0]],[[.5,-.4],[1,0],[.5,.4]]];}
function gSquiggle(rnd){const p=[],n=30,w=R(rnd,3,5);for(let i=0;i<=n;i++){const f=i/n;p.push([f*2-1,Math.sin(f*Math.PI*w)*.5]);}return[p];}
function gCross(){return[[[-1,-1],[1,1]],[[1,-1],[-1,1]]];}
function gBang(){return[[[0,-1],[.05,.35]],[[.04,.7],[.05,.92]]];}
function gBurst(rnd){const out=[],n=Math.floor(R(rnd,6,10));for(let i=0;i<n;i++){const a=i/n*Math.PI*2;out.push([[Math.cos(a)*.25,Math.sin(a)*.25],[Math.cos(a),Math.sin(a)]]);}return out;}
const GENS=[gCircle,gSpiral,gZig,gBolt,gStar,gArrow,gSquiggle,gCross,gBang,gBurst,gCircle,gSquiggle,gStar];

function init(st){
  st.s.font = st.tk.registerFamily('ForgeImpact', FONTS.impact) || undefined;
  st.s.doodles=[]; st.s.lastSpawn=0; st.s.slab=''; st.s.lastSlab=0;
  // drifting background watermark letters (optional)
  const wm=(st.opts && st.opts.watermark)||'';
  st.s.wm=wm.toUpperCase().split('').filter(c=>c.trim());
  st.s.wmL=st.s.wm.map((ch,i)=>({ch,slot:i,cx:0,ph:st.rnd()*6.28}));
}
function spawnDoodle(st,burst){
  const d=st.s.doodles, rnd=st.rnd;
  if(d.length>=18)d.shift();
  let cx,cy,tries=0;do{cx=R(rnd,.05,.95)*st.W;cy=R(rnd,.08,.92)*st.H;tries++;}while(tries<6&&cx>st.W*.2&&cx<st.W*.8&&cy>st.H*.34&&cy<st.H*.66);
  const gen=GENS[Math.floor(rnd()*GENS.length)];
  d.push({strokes:gen(rnd),x:cx,y:cy,scale:R(rnd,60,200)*(burst?1.15:1),rot:R(rnd,-Math.PI,Math.PI),red:rnd()<.26,lw:R(rnd,2,4.5),born:st.NOW,life:R(rnd,2600,4200),seed:R(rnd,0,1000)});
}
function onBeat(st,power){ spawnDoodle(st,true); if(power>1.1)spawnDoodle(st,true);
  if(power>1.05){const A='ABCDEFGHIJKLMNOPQRSTUVWXYZ';st.s.slab=A[Math.floor(st.rnd()*26)];} }
function onCue(st){ const A='!?*#@'; st.s.slab=A[Math.floor(st.rnd()*A.length)]; }

function background(ctx,st){
  const tk=st.tk;
  // readability scrim when compositing over footage
  if(st.overlayMode){const g=ctx.createLinearGradient(0,st.H*0.5,0,st.H);g.addColorStop(0,'rgba(0,0,0,0)');g.addColorStop(1,'rgba(0,0,0,0.45)');ctx.fillStyle=g;ctx.fillRect(0,st.H*0.5,st.W,st.H*0.5);}
  // ghost slab letter + watermark are dark fills meant for a black bg — skip over footage
  if(!st.overlayMode && st.s.slab){const gl=tk.glyph(st.s.slab,640,palette.ink);ctx.drawImage(gl.img,st.CX-gl.half,st.CY-gl.half);}
  // drifting watermark
  if(!st.overlayMode) for(const L of st.s.wmL){
    const sp=150,slotX=(L.slot-(st.s.wm.length-1)/2)*sp;
    const dx=Math.sin(st.NOW/1500+L.ph)*26, dy=Math.cos(st.NOW/1850+L.ph*1.3)*22;
    L.cx+=(slotX+dx-L.cx)*0.07;
    const gl=tk.glyph(L.ch,230,'#1b1b1b');
    ctx.save();ctx.translate(st.CX+L.cx,st.CY+dy);ctx.drawImage(gl.img,-gl.half,-gl.half);ctx.restore();
  }
  // doodles (ambient spawn — music only; talk stays clean & caption-focused)
  if(st.reactive && st.NOW-st.s.lastSpawn>(st.s.doodles.length<6?420:900)){st.s.lastSpawn=st.NOW;spawnDoodle(st,false);}
  ctx.lineCap='round';ctx.lineJoin='round';
  for(let i=st.s.doodles.length-1;i>=0;i--){const o=st.s.doodles[i];const ageF=(st.NOW-o.born)/o.life;
    if(ageF>=1){st.s.doodles.splice(i,1);continue;}
    const reveal=Math.min(1,ageF/0.28);let alpha=ageF<0.28?ageF/0.28:ageF>0.8?(1-ageF)/0.2:1;alpha*=o.red?0.92:0.7;
    ctx.save();ctx.translate(o.x,o.y);ctx.rotate(o.rot);ctx.scale(o.scale,o.scale);ctx.lineWidth=o.lw/o.scale;
    ctx.strokeStyle=o.red?'rgba(255,23,23,'+alpha.toFixed(3)+')':'rgba(250,250,245,'+alpha.toFixed(3)+')';
    let total=0;o.strokes.forEach(s=>total+=s.length);let budget=Math.floor(reveal*total);
    const jit=()=>Math.sin((st.NOW/90)+o.seed)*0.018;
    for(const s of o.strokes){if(budget<=1)break;const m=Math.min(s.length,budget);budget-=s.length;
      ctx.beginPath();for(let j=0;j<m;j++){const px=s[j][0]+jit(),py=s[j][1]+jit();j?ctx.lineTo(px,py):ctx.moveTo(px,py);}ctx.stroke();}
    ctx.restore();
  }
  // ---- reactive bar strip (bottom): chunky collage equalizer (music only) ----
  if(st.spectrum && st.reactive){
    const {NB,data}=st.spectrum,f=st.f,bw=st.W/NB,base=st.H-26;
    for(let i=0;i<NB;i++){const v=(data[f*NB+i]||0)/255;const bh=8+v*120;
      ctx.fillStyle=(i%4===0)?palette.accent:(st.overlayMode?'rgba(250,250,245,0.55)':palette.fg);
      ctx.globalAlpha=st.overlayMode?0.5:0.9;
      ctx.fillRect(i*bw+bw*0.12,base-bh,bw*0.76,bh);}
    ctx.globalAlpha=1;
  }
}

function paintToken(ctx,o){
  const {T,cx,cy,px,scl,rot,alpha,emph,st}=o;
  const tk=st.tk;
  ctx.save();ctx.globalAlpha=alpha;ctx.translate(cx,cy);ctx.rotate(rot);ctx.scale(scl,scl);
  ctx.font=tk.font(px,900,st.s.font);ctx.textAlign='center';ctx.textBaseline='middle';
  const w=ctx.measureText(T).width;
  if(emph){
    ctx.fillStyle=palette.accent;tk.chip(ctx,T,px,0.18,0.14,px*0.08);ctx.fill();
    ctx.fillStyle='#000';ctx.fillText(T,0,0);
  }else{
    ctx.fillStyle=palette.fg;ctx.fillText(T,0,0);
  }
  ctx.restore();
}

function drawCue(ctx,st){ const anchor=st.overlayMode?0.72:'center'; layoutCue(ctx,st,{sizes:{big:172,mid:136,small:66},anchor,safeW:0.94,reveal:0.28,perLetter:true,letterStagger:0.026,trans:0.18,family:st.s.font,paintToken}); }

function overlay(ctx,st){
  const tk=st.tk;
  ctx.drawImage(tk.vignette(0.9,300),0,0);
  if(Math.floor(st.t*st.fps)%2===0){ctx.save();ctx.globalAlpha=0.08;ctx.globalCompositeOperation='screen';ctx.drawImage(tk.grain(),-Math.random()*100,-Math.random()*100);ctx.restore();}
  if(st.flash>0.01){ctx.save();ctx.globalAlpha=st.flash;ctx.globalCompositeOperation='screen';ctx.fillStyle=palette.accent;ctx.fillRect(0,0,st.W,st.H);ctx.restore();}
  // progress bar
  ctx.fillStyle=palette.accent;ctx.fillRect(0,st.H-8,st.W*st.progress,8);
}

module.exports={ id:'utypisk', label:'Punk · kinetic slam', palette, layout:{}, init, background, drawCue, overlay, onBeat, onCue, paintToken };
